import React from 'react';
import Box from '@material-ui/core/Box';

import { PLAYER_PAGE_CARD_MAX_WIDTH } from './public-edit-player.constants';

interface IPlayerPageCardProps {
  children: React.ReactNode;
  // Inner padding: the page ranges from a tight header to roomy message cards.
  padding?: string;
  // Nested inside another card (one ice time in the ice-times list), so it
  // fills its parent instead of taking the page's own column width.
  nested?: boolean;
  centered?: boolean;
  gutterTop?: boolean;
  gutterBottom?: boolean;
}

// The player page's card chrome in one place. Every surface on the page renders
// through this, so a border or radius change lands on all of them at once.
export const PlayerPageCard: React.FC<IPlayerPageCardProps> = ({
  children,
  padding = '16px',
  nested,
  centered,
  gutterTop,
  gutterBottom,
}) => (
  <Box
    style={{
      background: '#ffffff',
      border: '1px solid #e5e7eb',
      borderRadius: 12,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04)',
      padding,
      ...(centered ? { textAlign: 'center' as const } : {}),
      ...(nested
        ? { marginBottom: 12 }
        : {
          maxWidth: PLAYER_PAGE_CARD_MAX_WIDTH,
          margin: `${gutterTop ? 24 : 0}px auto ${gutterBottom ? 16 : 0}px`,
        }),
    }}
  >
    {children}
  </Box>
);
